module.exports = __webpack_public_path__ + "img/cotton.db88754f.png";